import {
  Dialog,
  DialogContent,
  DialogClose,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Download, Trash2, X } from "lucide-react";
import { AuthImage } from "./AuthImage";
import { fmtDate } from "./format";

export const PhotoViewerModal = ({ viewPhoto, onOpenChange, onDownload, onDelete, canDeletePhotos }) => (
  <Dialog open={!!viewPhoto} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-3xl p-0 gap-0 bg-[#1f2730] border-[#33424f] [&>button]:hidden" data-testid="photo-modal">
      <div className="flex items-center justify-between px-4 py-3 border-b border-white/10">
        <div className="min-w-0">
          <DialogTitle className="text-white text-sm font-medium truncate">
            {viewPhoto?.original_file_name}
          </DialogTitle>
          <DialogDescription className="text-white/50 text-[11px]">
            {fmtDate(viewPhoto?.uploaded_at)}
            {viewPhoto?.uploaded_by_name ? ` · ${viewPhoto.uploaded_by_name}` : ""}
          </DialogDescription>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button
            type="button"
            onClick={() => viewPhoto && onDownload(viewPhoto)}
            data-testid="modal-download-btn"
            className="h-11 w-11 inline-flex items-center justify-center text-white/80 hover:text-white hover:bg-white/10 rounded"
            aria-label="Download"
            title="Download"
          >
            <Download className="w-5 h-5" />
          </button>
          {canDeletePhotos && viewPhoto && (
            <button
              type="button"
              onClick={() => onDelete(viewPhoto)}
              data-testid="modal-delete-btn"
              className="h-11 w-11 inline-flex items-center justify-center text-[#ff6b8a] hover:bg-white/10 rounded"
              aria-label="Delete"
              title="Delete"
            >
              <Trash2 className="w-5 h-5" />
            </button>
          )}
          <DialogClose asChild>
            <button
              type="button"
              data-testid="modal-close-btn"
              className="h-11 w-11 inline-flex items-center justify-center text-white/80 hover:text-white hover:bg-white/10 rounded"
              aria-label="Close"
              title="Close"
            >
              <X className="w-5 h-5" />
            </button>
          </DialogClose>
        </div>
      </div>

      <div className="bg-[#11161b] flex items-center justify-center min-h-[50vh] max-h-[70vh] overflow-auto">
        {viewPhoto && (
          <AuthImage
            key={`preview-${viewPhoto.id}`}
            src={`/photos/${viewPhoto.id}/preview`}
            alt={viewPhoto.original_file_name}
            className="max-w-full max-h-[70vh] object-contain"
          />
        )}
      </div>
    </DialogContent>
  </Dialog>
);
